//import "../css/style.scss"

// Our modules / classes
//import MobileMenu from "./modules/MobileMenu.js"
import Search from "./modules/Search.js"
import MesNotes from "./modules/MesNotes.js"
import ClickForGlossary from "./modules/ClickForGlossary.js"

// Instantiate a new object using our modules/classes
//const mobileMenu = new MobileMenu()
const search = new Search()
const mesNotes = new MesNotes()
const clickForGlossary = new ClickForGlossary()





